import TENetworkActivity from './TENetworkActivity';

export default TENetworkActivity;
